// returns the current window and document object if run in a browser
// returns the global and global.document objects if run in our tests

var root = (typeof(global) !== 'undefined' && global) || (typeof(window) !== 'undefined' && window);
var win;
var doc;

if(typeof process === 'object' && process + '' === '[object process]'){
  // is node
  win = root.window;
  doc = root.document;
} else {
  // not node
  win = window;
  doc = document;
}

module.exports = {
  window: win,
  document: doc
};
